import React from 'react';
import { hooks } from 'mage-i18n';
import { Typography } from '@klarna/bubble-ui';
import { HelpbotLink } from '../HelpbotLink';
const UncapturedOrdersNoBotMessage = () => {
    const t = hooks.useTranslator();
    const href1 = '/orders/all?sort_field=created_at&sort_direction=DESC&created_at_start=2022-06-29&help-page=tour%3Aorders';
    const link1 = React.createElement(HelpbotLink, { href: href1 }, t('helpbot.explanations.orders.uncapturedNoLink1'));
    return (React.createElement(React.Fragment, null,
        React.createElement(Typography, { textToken: 'text-style/text/super-paragraphs/body/regular' }, t('helpbot.explanations.orders.uncapturedNoPart1')),
        React.createElement(Typography, { textToken: 'text-style/text/super-paragraphs/body/regular' }, t('helpbot.explanations.orders.uncapturedNoPart2', { link1 }))));
};
export default UncapturedOrdersNoBotMessage;
